<template>
  <q-menu
    bordered
    side="right"
    touch-position
    context-menu
  >
    <q-list>
      <q-item
        v-if="canEditAtlasReport"
        v-close-popup
        clickable
        @click.stop="$emit('edit')"
      >
        <q-item-section avatar>
          <q-icon name="edit" />
        </q-item-section>
        <q-item-section>
          Edit {{ reportElement.name }}
        </q-item-section>
      </q-item>

      <q-separator />

      <q-item
        v-if="editing && canEditAtlasReport"
        v-close-popup
        clickable
        @click.stop="duplicate()"
      >
        <q-item-section avatar>
          <q-icon name="content_copy" />
        </q-item-section>
        <q-item-section>
          Duplicate {{ selectedElementIds.length ? '(' + selectedElementIds.length + ' Elements)' : reportElement.name }}
        </q-item-section>
      </q-item>
      <q-item
        v-if="editing && reportElement.migratable"
        v-close-popup
        clickable
        @click.stop="$emit('migrate-element')"
      >
        <q-item-section avatar>
          <q-icon name="new_releases" />
        </q-item-section>
        <q-item-section>
          Migrate {{ reportElement.name }}
        </q-item-section>
      </q-item>
      <q-item
        v-close-popup
        clickable
        @click.stop="copy()"
      >
        <q-item-section avatar>
          <q-icon name="content_copy" />
        </q-item-section>
        <q-item-section>
          Copy {{ selectedElementIds.length ? '(' + selectedElementIds.length + ' Elements)' : reportElement.name }}
        </q-item-section>
      </q-item>
      <q-item
        v-if="editing && canEditAtlasReport"
        v-close-popup
        clickable
        :disable="copiedElementIds.length === 0"
        @click.stop="paste()"
      >
        <q-item-section avatar>
          <q-icon name="content_paste" />
        </q-item-section>
        <q-item-section>
          Paste {{ copiedElementIds.length ? '(' + copiedElementIds.length + ' Elements)' : '' }}
        </q-item-section>
      </q-item>
      <q-item
        v-if="editing && canEditAtlasReport && reportElement.filterable && copiedElement && copiedElement.filterable"
        clickable
        :disable="!copiedElement"
      >
        <q-item-section avatar>
          <q-icon name="content_paste" />
        </q-item-section>
        <q-item-section>
          Paste Special
        </q-item-section>
        <q-item-section side>
          <q-icon name="keyboard_arrow_right" />
        </q-item-section>
        <q-menu
          anchor="top end"
          self="top start"
        >
          <q-list>
            <q-item
              v-close-popup
              clickable
              :disable="!copiedElement"
              @click.stop="$emit('paste-special', 'groupings')"
            >
              <q-item-section avatar>
                <q-icon name="category" />
              </q-item-section>
              <q-item-section>
                Paste Groupings
              </q-item-section>
            </q-item>
            <q-item
              v-close-popup
              clickable
              :disable="!copiedElement"
              @click.stop="$emit('paste-special', 'filters')"
            >
              <q-item-section avatar>
                <q-icon name="filter_alt" />
              </q-item-section>
              <q-item-section>
                Paste Filters
              </q-item-section>
            </q-item>
            <q-item
              v-close-popup
              clickable
              :disable="!copiedElement"
              @click.stop="$emit('paste-special', 'columns')"
            >
              <q-item-section avatar>
                <q-icon name="table_chart" />
              </q-item-section>
              <q-item-section>
                Paste Columns
              </q-item-section>
            </q-item>
          </q-list>
        </q-menu>
      </q-item>
      <q-separator />
      <template v-if="reportElement.filterable && canEditAtlasReport">
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('edit-groupings')"
        >
          <q-item-section avatar>
            <q-icon name="category" />
          </q-item-section>
          <q-item-section>
            Edit Groupings
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('edit-filters')"
        >
          <q-item-section avatar>
            <q-icon name="filter_alt" />
          </q-item-section>
          <q-item-section>
            Edit Filters
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('edit-columns')"
        >
          <q-item-section avatar>
            <q-icon name="bar_chart" />
          </q-item-section>
          <q-item-section>
            Edit Data
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="reportElement.resetAllFilters(); $emit('preview-changes')"
        >
          <q-item-section avatar>
            <q-icon name="clear" />
          </q-item-section>
          <q-item-section>
            Clear Filters
          </q-item-section>
        </q-item>
        <q-separator />
        <q-item
          v-close-popup
          clickable
          @click.stop="$emit('show-source')"
        >
          <q-item-section avatar>
            <q-icon name="source" />
          </q-item-section>
          <q-item-section>
            View Source
          </q-item-section>
        </q-item>
      </template>
      <q-separator v-if="editing" />
      <q-item
        v-if="editing && canEditAtlasReport"
        v-close-popup
        clickable
        @click.stop="deleteElements()"
      >
        <q-item-section avatar>
          <q-icon name="delete" />
        </q-item-section>
        <q-item-section>
          Delete {{ selectedElementIds.length ? '(' + selectedElementIds.length + ' Elements)' : reportElement.name }}
        </q-item-section>
      </q-item>
      <q-separator v-if="editing" />
      <q-item
        v-if="editing && canEditAtlasReport"
        v-close-popup
        clickable
        @click.stop="$emit('advanced-edit')"
      >
        <q-item-section avatar>
          <q-icon name="settings" />
        </q-item-section>
        <q-item-section>
          Advanced Settings
        </q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script>

export default {
  name: 'ReportElementMenu',
  props: {
    reportElement: {
      type: Object,
      required: true
    },
    editing: {
      type: Boolean,
      required: false,
      default: false
    },
    selectedElementIds: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    copiedElementIds: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },
    copiedElement: {
      type: Object,
      required: false,
      default: null
    },
    fromAtlas: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['edit', 'migrate-element', 'paste-special', 'edit-groupings', 'edit-filters', 'edit-columns', 'preview-changes', 'show-source', 'advanced-edit', 'duplicate-elements', 'delete-elements', 'copy-elements', 'paste-elements'],
  context: ['currentUser'],
  data () {
    return {
    }
  },
  computed: {
    canEditAtlasReport () {
      // Allow editing if not from Atlas, or if user is a superuser
      return !this.fromAtlas || this.currentUser?.superUser
    }
  },
  methods: {
    duplicate () {
      if (this.selectedElementIds.length) {
        this.$emit('duplicate-elements', this.selectedElementIds)
      } else {
        this.$emit('duplicate-elements', [this.reportElement.id])
      }
    },
    deleteElements () {
      if (this.selectedElementIds.length) {
        this.$emit('delete-elements', this.selectedElementIds)
      } else {
        this.$emit('delete-elements', [this.reportElement.id])
      }
    },
    async copy () {
      if (this.selectedElementIds.length) {
        this.$emit('copy-elements', this.selectedElementIds)
      } else {
        this.$emit('copy-elements', [this.reportElement.id])
      }
    },
    async paste () {
      this.$emit('paste-elements', this.reportElement)
    }
  }
}
</script>
